module.exports = __webpack_public_path__ + "img/dot_add_key.c11a2cd6.svg";